import { render, staticRenderFns } from "./Addvertisement.vue?vue&type=template&id=1af46274&scoped=true"
import script from "./Addvertisement.vue?vue&type=script&lang=js"
export * from "./Addvertisement.vue?vue&type=script&lang=js"
import style0 from "./Addvertisement.vue?vue&type=style&index=0&id=1af46274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af46274",
  null
  
)

export default component.exports